import { withApollo } from "react-apollo";
import { useWidgets } from "./useWidgets";

const GetWidgets = ({ client }) => {
  useWidgets(client);
  return null;
};

export default withApollo(GetWidgets);
